import React from "react";
import Contact_content from "./content";
import Contact_header from "./header";

function Contact_components(){

    return(
        <div id="contact">
            <Contact_header />
            <Contact_content />
        </div>
    );

}

export default Contact_components;